<template>
  <div class="newsDetail" v-if="!isLoading">
    <div class="video-container-sticky">
      <div class="video-container">
        <video
          id="player"
          preload=""
          webkit-playsinline=""
          x-webkit-airplay="true"
          playsinline="true"
          controls="controls"
          :src="articleInfo.video_url"
          :poster="articleInfo.image_input[0]"
        ></video>
      </div>
    </div>

    <div
      class="atc-m-card"
      style="padding-top: 15px; padding-bottom: 0px; margin: 0px;"
    >
      <div data-v-695c7aba="" class="atc-header">
        <h1 class="atc-title" style="font-size: 18px;">
          {{ articleInfo.title }}
        </h1>
        <div class="author-gov">
          <div class="t">
            <img src="@assets/images/video_sign.jpeg" alt="" class="avatar" />
            <div class="info">
              <h3>
                时间视频
              </h3>
              <p>
                {{ articleInfo.add_time }} ·&nbsp;{{
                  articleInfo.author
                }}·&nbsp;{{ articleInfo.visit }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- recommend start -->
    <div class="atc-m-card video_container" v-if="recommend.length>0">
      <h3 class="atc-m-title title">
        相关推荐
      </h3>
      <ul class="atc-more-list video">
        <li class="atc-more-item" v-for="(item,index) in recommend" :key="index">
          <router-link :to="{ path: '/video_detail/' + item.id }">
          <div class="inner">
            <div class="cover-box">
              <img
                :alt="item.title"
                :data-src="item.image_input[0]"
                :src="item.image_input[0]"
                lazy="loaded"
              />
              <div class="cover-time">
                <span class="iconfont icon-liulan"></span>&nbsp;{{item.visit}}</span>
              </div>
            </div>
            <div class="btm">
              <p class="video_title">
                {{item.title}}
              </p>
            </div>
          </div>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- recommend end -->

    <div class="bnt bg-color-red" v-if="isWeixin" @click="setShareInfoStatus">
      和好友一起分享
    </div>
    <ShareInfo
      v-on:setShareInfoStatus="setShareInfoStatus"
      :shareInfoStatus="shareInfoStatus"
    ></ShareInfo>
  </div>
</template>
<style scoped>
/* video start */
.video-container-sticky {
  position: -webkit-sticky;
  position: sticky;
  z-index: 9;
}
.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  overflow: hidden;
  background-color: #000;
}
.video-container {
  position: relative;
  z-index: 9;
  top: 0;
  width: 100%;
  padding-bottom: 56%;
}
.video-container > video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
}
.atc-m-card {
  margin-bottom: 0.1rem;
  padding: 0 0.3rem 0.8rem;
  background-color: #fff;
  padding-top: 0.3rem;
  padding-bottom: 0px;
  margin: 0px;
}
.atc-header {
  margin-bottom: 0.1rem;
}
.atc-title {
  margin-bottom: 0.2rem;
  font-size: 0.4rem;
  color: #333;
  word-break: break-word;
  font-size: 0.36rem;
}
.author-gov > .t {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.author-gov > .t .avatar {
  width: 0.72rem;
  height: 0.72rem;
  border-radius: 999px;
}
.author-gov > .t .info {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin: 0 0.16rem;
  min-width: 0;
}
.author-gov > .t .info h3 {
  font-size: 0.28rem;
  color: #333;
  height: 0.4rem;
  line-height: 0.4rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.author-gov > .t .info p {
  height: 0.34rem;
  line-height: 0.34rem;
  padding-top: 0.02rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.24rem;
  color: #999;
}
.atc-m-card {
  margin-bottom: 0.1rem;
  padding: 0 0.3rem 0.8rem;
  background-color: #fff;
}
.atc-m-card {
  padding: 0.3rem 0.3rem 0;
}
.atc-m-title {
  margin: 0;
  padding: 0 0 0.1rem;
  font-family: PingFangSC-Semibold;
  font-size: 0.36rem;
  color: #333;
  letter-spacing: 0;
  line-height: 0.52rem;
}
.atc-more-list.video {
  margin: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: -webkit-calc(100% + 0.2rem);
  width: calc(100% + 0.2rem);
}
.atc-more-list.video .atc-more-item {
  width: 50%;
  margin-bottom: 0.4rem;
  padding-right: 0.2rem;
  box-sizing: border-box;
}
.atc-more-list.video .atc-more-item .inner {
  background: #fff;
  border-radius: 0.06rem;
  overflow: hidden;
}
.atc-more-list.video .atc-more-item .cover-box {
  border-radius: 0.06rem;
  position: relative;
  padding-bottom: 56.25%;
  overflow: hidden;
}
.atc-more-list.video .atc-more-item .cover-box > img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
.atc-more-list.video .atc-more-item .cover-box .cover-time {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.58rem;
  padding-right: 0.2rem;
  box-sizing: border-box;
  line-height: 0.58rem;
  text-align: right;
  background-image: linear-gradient(-180deg, transparent, rgba(0, 0, 0, 0.4));
  font-size: 0.24rem;
  color: #fff;
  text-shadow: 0 0.02rem 0 rgba(0, 0, 0, 0.5);
}
.atc-more-list.video .atc-more-item .btm {
  padding: 0.1rem 0 0;
}
.atc-more-list.video .atc-more-item .video_title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  word-break: break-all;
  overflow: hidden;
  font-size: 0.28rem;
  color: #333;
}
/* video end */
.newsDetail .picTxt {
  width: 6.9rem;
  height: 2rem !important;
  border-radius: 0.2rem;
  border: 1px solid #e1e1e1;
  position: relative;
  margin: 0.3rem auto 0 auto;
}
.newsDetail .picTxt .pictrue {
  width: 2rem;
  height: 2rem;
}
.newsDetail .picTxt .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 0.2rem 0 0 0.2rem;
  display: block;
}
.newsDetail .picTxt .text {
  width: 4.6rem;
}
.newsDetail .picTxt .text .name {
  font-size: 0.3rem;
  color: #282828;
}
.newsDetail .picTxt .text .money {
  font-size: 0.24rem;
  margin-top: 0.4rem;
  font-weight: bold;
}
.newsDetail .picTxt .text .money .num {
  font-size: 0.36rem;
}
.newsDetail .picTxt .text .y_money {
  font-size: 0.26rem;
  color: #999;
  text-decoration: line-through;
}
.newsDetail .picTxt .label {
  position: absolute;
  background-color: #303131;
  width: 1.6rem;
  height: 0.5rem;
  right: -0.07rem;
  border-radius: 0.25rem 0 0.06rem 0.25rem;
  text-align: center;
  line-height: 0.5rem;
  bottom: 0.24rem;
}
.newsDetail .picTxt .label .span {
  background-image: linear-gradient(to right, #fff71e 0%, #f9b513 100%);
  background-image: -webkit-linear-gradient(to right, #fff71e 0%, #f9b513 100%);
  background-image: -moz-linear-gradient(to right, #fff71e 0%, #f9b513 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.newsDetail .picTxt .label:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  border-bottom: 0.08rem solid #303131;
  border-right: 0.08rem solid transparent;
  top: -0.08rem;
  right: 0;
}
.newsDetail .bnt {
  color: #fff;
  font-size: 0.3rem;
  width: 6.9rem;
  height: 0.9rem;
  border-radius: 0.45rem;
  margin: 0.48rem auto 0 auto;
  text-align: center;
  line-height: 0.9rem;
}
</style>
<script>
import Vue from "vue";
import { Skeleton } from "vant";
import { getVideoDetails } from "@api/public";
import ShareInfo from "@components/ShareInfo";
import { isWeixin } from "@utils/index";
import { openShareAll } from "@libs/wechat";

export default {
  name: "NewsDetail",
  components: { ShareInfo },
  props: {},
  data: function() {
    return {
      articleInfo: {},
      storeInfo: {},
      shareInfoStatus: false,
      isWeixin: isWeixin(),
      isLoading: true,
      recommend:{}
    };
  },
  watch: {
     $route: function(to, from) {
      if (to.path !== from.path) {
        this.articleDetails();
      }
    }
  },
  mounted: function() {
    Vue.use(Skeleton);
    this.articleDetails();
  },
  methods: {
    updateTitle() {
      document.title = this.articleInfo.title || this.$route.meta.title;
    },
    articleDetails: function() {
      let that = this,
        id = this.$route.params.id;
      getVideoDetails(id).then(res => {
        that.articleInfo = res.data.content;
        that.storeInfo = res.data.store_info || {};
        that.recommend = res.data.recommend || {};
        that.updateTitle();
        if (that.isWeixin) that.share();
        that.isLoading = false;
      });
    },
    setShareInfoStatus: function() {
      this.shareInfoStatus = !this.shareInfoStatus;
    },
    share: function() {
      openShareAll({
        desc: this.articleInfo.synopsis,
        title: this.articleInfo.title,
        link: location.href,
        imgUrl: this.articleInfo.image_input.length
          ? this.articleInfo.image_input[0]
          : ""
      });
    }
  }
};
</script>
